export default {
    search_action_placeholder: "Buscar acción...",
    search_client_placeholder: "Buscar cliente...",
    search_placeholder: "Buscar...",
    close: "Cerrar",
    cancel: "Cancelar",
    apply: "Aplicar",
    select: "Seleccione",
    select_client: "Seleccione el cliente",
    select_branches: "Seleccione las sucursales",
    client_no_registration: "Cliente sin registro",
    all: "Todos",
    enter_dates: "Ingrese las fechas",
    enter_values: "Ingrese los valores",
    up_to: "Hasta {0}",
    after: "Después de {0}",
    from: "Desde {0}",
    between: "Entre {0} y {1}",
    not_informed: "No informado",
    restrict_time_range: "Limitar intervalo de tiempo",
    days_ago_title: "Días atrás",
    period_days_ago: "Período: {0} días atrás.",
    more_than: "Más de {0}",
    date_picker: {
        days_of_week: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
        months: [
            "Ene", "Feb", "Mar", "Abr", "May", "Jun",
            "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
        ],
    },
    ranges: {
        today: "Hoy",
        yesterday: "Ayer",
        this_month: "Este mes",
        this_year: "Este año",
        last_month: "Mes pasado",
        last_year: "Año pasado",
        all_period: "Todo el período",
    },
    last_12_months: "Últimos 12 meses",
    last_3_months: "Últimos 3 meses",
    last_x_days: "Últimos {0} días",
    min: "Mínimo",
    max: "Máximo",
};
